import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ERPConfiguration  {
    _originalTypeClassName = "zERP.BO.ERPConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ERPConfiguration.translate = translateService;
}
this.PaymentOrderApprovalConditions = [];
this.Id = null;
this.BudgetingUseApproval = false;
this.BudgetingAmountsShouldMatch = false;
this.InvoiceLineWithoutSpendingRequestValidation = null;
this.SpendingRequestApprovalCondition = null;
this.AllowMassDeleteIssuedInvoices = false;
this.DefaultTransactionItemType = null;
this.UseNetAmountForAssetsValue = false;
this.UseGrossAmountOnBudget = false;
this.FMY_DisabilityPercentage = null;
this.FMY_Minor = null;
this.FMY_MaxAge = null;
this.AllowBenefitOverlapping = false;
this.ReferenceDateNewInsured = null;
this.FamilyProvision_DisabilityPercentage = null;
this.DefinitionLevel = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
BudgetingUseApproval:any;
BudgetingAmountsShouldMatch:any;
InvoiceLineWithoutSpendingRequestValidation:any;
SpendingRequestApprovalCondition:any;
AllowMassDeleteIssuedInvoices:any;
DefaultTransactionItemType:any;
UseNetAmountForAssetsValue:any;
UseGrossAmountOnBudget:any;
FMY_DisabilityPercentage:any;
FMY_Minor:any;
FMY_MaxAge:any;
AllowBenefitOverlapping:any;
ReferenceDateNewInsured:any;
FamilyProvision_DisabilityPercentage:any;
DefinitionLevel:any;
Logo:any;
PaymentOrderApprovalConditions:any;
CancellationInvoiceType:any;
PaymentOrderWithCheckDynamicReport:any;
static setLogo = ($this, value) => {
var oldValue = $this.Logo;
$this.Logo = value;
if (value != null) {
}
}
static setPaymentOrderApprovalConditions = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentOrderApprovalConditions == null) $this.PaymentOrderApprovalConditions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentOrderApprovalConditions.length > 0) {
                    Domain.ERPConfiguration.removePaymentOrderApprovalConditions($this, $this.PaymentOrderApprovalConditions[0]);
                }

                Domain.ERPConfiguration.addManyPaymentOrderApprovalConditions($this, copyItems);
            }
static addManyPaymentOrderApprovalConditions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ERPConfiguration.addPaymentOrderApprovalConditions($this, items[i]);
                }
            }
static addPaymentOrderApprovalConditions = ($this, item) => {
                if ($this.PaymentOrderApprovalConditions == null) $this.PaymentOrderApprovalConditions = [];
                if (item == null || $this.PaymentOrderApprovalConditions.indexOf(item) > -1) return;
                $this.PaymentOrderApprovalConditions.push(item);
}
static addRangePaymentOrderApprovalConditions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ERPConfiguration.addPaymentOrderApprovalConditions($this, item));
            }
static removePaymentOrderApprovalConditions = ($this, item) => {
                if ($this == null || $this.PaymentOrderApprovalConditions == null || $this.PaymentOrderApprovalConditions.indexOf(item) === -1) return;
                var _index = $this.PaymentOrderApprovalConditions.indexOf(item);
                $this.PaymentOrderApprovalConditions.splice(_index, 1);
}
static clearPaymentOrderApprovalConditions = ($this) => { $this.PaymentOrderApprovalConditions = null; }
static setCancellationInvoiceType = ($this, value) => {
var oldValue = $this.CancellationInvoiceType;
$this.CancellationInvoiceType = value;
if (value != null) {
}
}
static setPaymentOrderWithCheckDynamicReport = ($this, value) => {
var oldValue = $this.PaymentOrderWithCheckDynamicReport;
$this.PaymentOrderWithCheckDynamicReport = value;
if (value != null) {
}
}

static CanAutoApprovePaymentOrder($this: any, methodIds: any,amount: any): any{if (!($this?.PaymentOrderApprovalConditions?.linq?.any())) {return false;}
let passpartou = $this?.PaymentOrderApprovalConditions?.linq?.where((l) => l?.PaymentMethod == null)?.firstOrDefault(null);
if (passpartou != null && !(methodIds?.linq?.any())) {return CLMS.Framework.Number.GreaterThanOrEqual(() => passpartou.ThreasholdAmount, () => amount);}
for (let _iline = 0; _iline < ($this?.PaymentOrderApprovalConditions == null ? 0 : $this?.PaymentOrderApprovalConditions.length); _iline++) {let line = $this?.PaymentOrderApprovalConditions[_iline];if (line?.PaymentMethod == null) {continue;}if (methodIds?.linq?.any((id) => CLMS.Framework.Number.Equal(() => line.PaymentMethod.Id, () => id))) {return CLMS.Framework.Number.GreaterThanOrEqual(() => line.ThreasholdAmount, () => amount);}}
if (passpartou != null) {return CLMS.Framework.Number.GreaterThanOrEqual(() => passpartou.ThreasholdAmount, () => amount);}
return false;
}
static CanAutoApproveSpendingRequest($this: any, amount: any): any{if (CLMS.Framework.Number.Equal(() => $this.SpendingRequestApprovalCondition, () => null) || CLMS.Framework.Number.LessThanOrEqual(() => $this.SpendingRequestApprovalCondition, () => 0)) {return false;}
return CLMS.Framework.Number.LessThan(() => amount, () => $this.SpendingRequestApprovalCondition);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}